import React, { useState, useEffect } from 'react';
import { StyledWhatsNewSection } from './WhatsNewSection.styles';
import { WhatsNewCard } from '../WhatsNewCard';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
export const WhatsNewSection = ({ title, cards, selectedFilters }) => {
    const [cardsToDisplay, setCardsToDisplay] = useState([]);
    useEffect(() => {
        setCardsToDisplay(() => selectedFilters?.length > 0
            ? cards.filter(({ tags }) => tags.some(tag => selectedFilters.includes(tag)))
            : [...cards]);
    }, [cards, selectedFilters]);
    if (cardsToDisplay?.length === 0) {
        return null;
    }
    return (React.createElement(StyledWhatsNewSection, null,
        React.createElement(Typography, { gutterBottom: true, variant: "h3", fontSize: 18, fontWeight: 600 }, title),
        React.createElement(Grid, { container: true, rowSpacing: 4, spacing: 6 }, cardsToDisplay?.map(({ title, ...props }) => (React.createElement(Grid, { key: title, item: true },
            React.createElement(WhatsNewCard, { title: title, ...props })))))));
};
